<template>
  <div>
    <h2>EBITDA por año fiscal</h2>
    <ebit type="EBITDA"/>
    <br>
    <h2>EBIT por año fiscal (hasta FY22)</h2>
    <ebit />
  </div>
</template>
<script>
import ebit from '@/modules/CA_SP/components/zz/ebit.vue';

export default {
  props: [],
  components:{ebit},
  data() {
    return {
      
    };
  },
  computed: {

  },
  watch: { },
  methods: {

  },
};
</script>
